import type { SVGProps } from "react"

/**
 * Marca da VPN ONZ: um escudo com fechadura, remetendo a segurança/privacidade.
 * Compartilha a mesma silhueta do favicon (`src/index.html`).
 *
 * O preenchimento usa `currentColor`, então herda a cor do contexto (ex.:
 * `text-primary`). A fechadura é vazada via `fill-rule="evenodd"`, deixando o
 * fundo aparecer através dela.
 */
export function BrandMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="VPN ONZ"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 8C32 8 22 13 13 15 12 15.3 11 16 11 19 11 34 13 47 32 57 51 47 53 34 53 19 53 16 52 15.3 51 15 42 13 32 8 32 8ZM32 21.6C35 21.6 37.4 24 37.4 27 37.4 29.2 36.1 31.1 34.2 32.2L36.2 40 27.8 40 29.8 32.2C27.9 31.1 26.6 29.2 26.6 27 26.6 24 29 21.6 32 21.6Z"
      />
    </svg>
  )
}
